<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">空防客舱扰乱事件处置系统</div>
      <div class="decision-head-right">
        <div class="decision-head-bt" @click="showHistoryListDialog=true"><img src="@/assets/images/yi.png" alt=""/>历史记录</div>
        <div class="decision-head-bt active" @click="$router.push('/index')"><img src="@/assets/images/yi2.png" alt=""/>回到首页
        </div>
      </div>
    </div>
    <div class="decision-page">
      <div class="Eventhandling-left backgroundList">
        <div class="Variousroles-head">各角色｜待办事项-完成情况</div>
        <div class="undefined" v-show="!showTaskCard">等待系统决策</div>
        <div class="Variousroles-ul" v-if="showTaskCard">
          <task-list-card v-for="role in RoleEnums.options()"
                          :key="role.key"
                          :event-id="id"
                          :event-type="eventType"
                          :role-key="role.key"
                          :role-comment="role.comment"
                          :done="eventDataRow.done||false"
                          :data-rows="eventVO.taskMap[role.key]"
                          :task-done-btn-enabled-att="eventVO.taskDoneBtnEnabledATT"
                          :task-done-btn-enabled-sc="eventVO.taskDoneBtnEnabledSC"
          />
        </div>
        <div v-if="showBtnAddTask" class="Variousroles-bt" @click="showAddTaskDialog=true">下派任务</div>
      </div>
      <div class="Eventhandling-center">
        <div class="center-top backgroundList">
          <camera-card :id="id" />
        </div>
        <div class="center-bottom backgroundList">
          <div class="inspection-h">应急处置-待办事项-检查单</div>
          <div class="undefined" v-show="!showTaskCard">等待系统决策</div>
          <task-todo-card v-if="showTaskCard"
                          :data-rows="eventVO.taskMap[client]"
                          :show-btn-discover="showBtnDiscover"
                          :task-done-btn-enabled="eventVO.taskDoneBtnEnabledSCDR"
                          :event-id="id"
                          :event-type="eventType"
                          :client="client"
                          :done="eventDataRow.done||false"
          />
        </div>
      </div>
      <div class="Eventhandling-right">
        <div class="right-top backgroundList">
          <div class="Aircraftclass-li">
            <div class="Aircraftclass-h">{{ eventDataRow.planeType||'' }}</div>
            <div class="Aircraftclass-p">飞机类别</div>
          </div>
          <div class="Aircraftclass-li">
            <div class="Aircraftclass-h">{{ eventDataRow.flightNo||'' }}</div>
            <div class="Aircraftclass-p">航班号</div>
          </div>
          <div class="Aircraftclass-li">
            <div class="Aircraftclass-h">{{ eventDataRow.planeId||'' }}/{{ eventDataRow.msn||'' }}
            </div>
            <div class="Aircraftclass-p">注册号/MSN编号</div>
          </div>
        </div>
        <!--active变成斗殴-->
        <div class="right-center" :class="!eventType?eventType:''" @click="popupCurrentResultDialog(true)">
          <div class="event-top">
            <div class="event-h">当前处置事件</div>
            <div class="event-p">{{ `${eventDataRow.typeComment||' '}事件` }}</div>
          </div>
          <!--等待决策-->
          <div v-if="eventResult === 'R0'||!eventType" class="event-bottom none" @click="showChooseTypeDialog=true">
            <div class="none-h"></div>
            <div class="none-p">等待现场状况评估</div>
          </div>
          <!--active黄色 active2绿色-->
          <div class="event-bottom" :class="eventResultColor">
            <div class="event-img">
              <img v-if="eventResultImage!==''" :src="eventResultImage" alt=""/>
              <div class="event-t">{{ eventVO.resultComment }}</div>
            </div>
          </div>
        </div>
        <div class="right-bottom backgroundList">
          <question-card v-if="eventDataRow.type" :client="client" :id="eventDataRow.id" :type="eventDataRow.type"
                         :input-enabled="!eventVO.taskMap" :data-row="eventVO.questionMap"/>
        </div>
      </div>
    </div>

    <history-list-dialog v-if="showHistoryListDialog" :dialogVisible="showHistoryListDialog" :client="client" @handle-close="showHistoryListDialog=false"/>
    <!--当前决策|重新选决策-->
    <soc-confirm-dialog v-if="alertSocConfirmDialog" :visible="alertSocConfirmDialog" :event-id="id" :event-type="eventType" :data-row="socConfirmDialog"/>
    <soc-done-confirm-dialog v-if="alertSocDoneConfirmDialog" :visible="alertSocDoneConfirmDialog" :event-type="eventType" :event-id="id" @handle-close="alertSocDoneConfirmDialog=false"/>
    <current-result-dialog v-if="alertCurrentResultDialog" :event-id="id" :done="eventDataRow.done" :data-row="currentResultDialog" :visible="alertCurrentResultDialog" :event-type="eventType" @handle-close="alertCurrentResultDialog=false"/>
    <choose-type-dialog v-if="alertChooseTypeDialog" :visible="alertChooseTypeDialog" :dv="eventDataRow.dv" :choose-type-dialog="eventDataRow.chooseTypeDialog" @close="showChooseTypeDialog=false"/>
    <!--下派任务-->
    <add-task-dialog v-if="showAddTaskDialog" :visible.sync="showAddTaskDialog" :event-id="id" :event-type="eventType"/>
  </div>
</template>

<script>
import isUndefined from 'lodash/isUndefined'
import isNull from 'lodash/isNull'
import {detailById} from '@/api/kecang'
import {RoleEnums} from '@/api/Enums'
import ChooseTypeDialog from "@/views/Eventhandling/components/ChooseTypeDialog.vue";
import SocConfirmDialog from "@/views/Eventhandling/components/SocConfirmDialog.vue";
import AddTaskDialog from "@/views/Eventhandling/components/AddTaskDialog.vue";
import TaskTodoCard from "@/views/Eventhandling/components/TaskTodoCard.vue";
import TaskListCard from "@/views/Eventhandling/components/TaskListCard.vue";
import CameraCard from "@/views/Eventhandling/components/CameraCard.vue";
import HistoryListDialog from "@/views/Eventhandling/components/HistoryListDialog.vue";
import SocDoneConfirmDialog from "@/views/Eventhandling/components/SocDoneConfirmDialog.vue";
import CurrentResultDialog from "@/views/Eventhandling/components/CurrentResultDialog.vue";
import QuestionCard from "@/views/Eventhandling/components/QuestionCard.vue";
import MixinMqttClient from "@/components/mqtt/MixinMqttClient";

const mapVO = {
  CET0: 'fireUserVO', // 纵火事件参数对象
  CET1: 'fightUserVO', // 斗殴事件参数对象
  CET2: 'threatenUserVO', //  劫炸机威胁事件参数对象
  CET3: 'violationUserVO', //  违规使用电子应急设备事件参数对象
  CET4: 'cockpitUserVO', // 冲击驾驶舱事件参数对象
  CET5: 'smokeUserVO', //  机上吸烟事件参数对象
  CET6: 'impactUserVO', //  冲击机场拒不下机事件参数对象
  CET7: 'threatenNewUserVO' //  劫炸机事件参数对象
}
const e2 = require('@/assets/images/e2.png')
const e3 = require('@/assets/images/e3.png')
const e4 = require('@/assets/images/e4.png')
const e6 = require('@/assets/images/e6.png')
const iconR3 = require('@/assets/images/icon-R3.png')
export default {
  name: "CabinEvent",
  components: {
    QuestionCard,
    CurrentResultDialog,
    SocDoneConfirmDialog,
    HistoryListDialog,
    CameraCard,
    TaskListCard,
    TaskTodoCard,
    AddTaskDialog,
    SocConfirmDialog,
    ChooseTypeDialog
  },
  mixins: [MixinMqttClient],
  data() {
    return {
      RoleEnums,
      client: this.$route.params.client,
      id: this.$route.params.id,
      hasSOC: this.$route.params.client === 'ROLE_SOC',
      eventDataRow: {},
      eventVO: {},
      showHistoryListDialog: false,
      showAddTaskDialog: false, // 下派任务弹窗控制
      alertCurrentResultDialog: false, // 当前决策弹窗
      currentResultDialog: null, // 当前决策弹窗
      alertSocConfirmDialog: false, // 所有问题回答完成：SOC是否需要弹出 系统决策建议 确认窗口；true:是, false:否
      socConfirmDialog: null,
      alertSocDoneConfirmDialog: false, // 所有待办事项完成：SOC是否需要弹出 系统决策建议 确认窗口；true:是, false:否
      socDoneConfirmDialog: null,
      showChooseTypeDialog: false
    }
  },
  created() {
    this.findById()
  },
  mounted() {
    this.subscribeTopic()
  },
  beforeDestroy() {
    if (this.topic){
      this.unsubscribeMQTT(this.topic)
    }
  },
  watch: {
    alertSocConfirmDialogValue: function (val) {
      // console.log(['watch alertSocConfirmDialogValue', val, this.eventVO.alertSocConfirmDialog])
      this.alertSocConfirmDialog = val
      this.socConfirmDialog = this.eventVO.socConfirmDialog
    },
    alertSocDoneConfirmDialogValue: function (val) {
      // console.log(['watch alertSocDoneConfirmDialogValue', val, this.eventVO.socDoneConfirmDialog])
      if (['CET1', 'CET3'].includes(this.eventType)) {
        // this.eventVO.socDoneConfirmDialog.options 有选项
        // 所有待办事项完成："系统决策 = 继续起飞" 时，SOC需要二次确认，且可以改变决策结果
        this.alertSocConfirmDialog = val
        this.socConfirmDialog = this.eventVO.socDoneConfirmDialog
      } else if (['CET5', 'CET6'].includes(this.eventType)) {
        // this.eventVO.socDoneConfirmDialog.options 无选项
        // 所有待办事项完成："系统决策 = 继续起飞" 时，SOC需要二次确认，不可以改变决策结果
        this.alertSocConfirmDialog = val
        this.socConfirmDialog = this.eventVO.socDoneConfirmDialog
      } else if (['CET0', 'CET2', 'CET4', 'CET7'].includes(this.eventType)) {
        // 所有待办事项完成：SOC二次确认事件是否已结束，不可以改变决策结果
        this.alertSocDoneConfirmDialog = val
        this.socDoneConfirmDialog = this.eventVO.socDoneConfirmDialog
      }
    },
    enableMQTT(newValue){
      if (newValue) {
        this.subscribeTopic()
      } else if (this.topic) {
        this.unsubscribeMQTT(this.topic);
      }
    },
    topic(newValue, oldValue) {
      if (newValue) {
        this.subscribeTopic();
      } else if (oldValue) {
        this.unsubscribeMQTT(oldValue);
      }
    }
  },
  computed: {
    eventType() {
      return this.eventDataRow.type || ''
    },
    enableMQTT() {
      if (this.disabledMQTT) {
        return false;
      }
      if (isUndefined(this.eventDataRow.done) || isNull(this.eventDataRow.done)) {
        return false;
      }
      if (this.eventDataRow.done) {
        return false;
      }
      if (!this.id) {
        return false;
      }
      return true;
    },
    topic() {
      return this.enableMQTT ? `PlaneCabinEventService/${this.id}` : "";
    },
    alertChooseTypeDialog() {
      return (this.eventDataRow.alertChooseTypeDialog || false) && this.showChooseTypeDialog
    },
    eventResult() {
      return this.eventVO.result || ''
    },
    showTaskCard() {
      // return this.client ==='ROLE_SOC' && this.eventVO.taskMap
      return !!this.eventVO.taskMap
    },
    showBtnAddTask() {
      return this.hasSOC && this.eventDataRow.done === false && this.showTaskCard
    },
    alertSocConfirmDialogValue() {
      // console.log(['alertSocConfirmDialogValue', this.eventVO.alertSocConfirmDialog])
      if (!this.hasSOC) {
        return false
      }
      return this.eventVO.alertSocConfirmDialog || false
    },
    alertSocDoneConfirmDialogValue() {
      // console.log(['alertSocDoneConfirmDialogValue', this.eventVO.alertSocDoneConfirmDialog])
      if (!this.hasSOC) {
        return false
      }
      return this.eventVO.alertSocDoneConfirmDialog || false
    },
    // 按钮：发现火情 、发现秩序失控 、发现爆炸风险
    showBtnDiscover(){
      return this.eventVO.showBtnDiscover || false
    },
    eventResultImage() {
      // <!--撤离-->
      // <img v-if="checkLevel('CET0','R1')" src="@/assets/images/e2.png"/>
      // <img v-if="checkLevel('CET0','R2')" src="@/assets/images/e2.png"/>
      // <!--创造起飞条件-->
      // <img v-if="checkLevel('CET1','R1')" src="@/assets/images/e3.png"/>
      // <!--滑回-->
      // <img v-if="checkLevel('CET1','R2')" src="@/assets/images/e4.png"/>
      // <!--继续飞行-->
      // <img v-if="checkLevel('CET1','R4')" src="@/assets/images/e6.png"/>
      switch (this.eventType) {
        case 'CET0': // 纵火
          switch (this.eventResult) {
            case 'R1': // 快速撤离
            case 'R2': // 紧急撤离
              return e2
            case 'R3': // 公司决策
              return iconR3
          }
          break
        case 'CET1': // 斗殴
          switch (this.eventResult) {
            case 'R1': // 创造起飞条件
              return e3
            case 'R2': // 滑回减员
              return e4
            case 'R3': // 公司决策
              return iconR3
            case 'R4': // 继续起飞
              return e6
          }
          break
        case 'CET2': // 劫炸机威胁
          switch (this.eventResult) {
            case 'R1' : // 立即滑回防爆停机位
            case 'R2' : // 紧急撤离
              return e2
          }
          break
        case 'CET3': // 违规使用电子/应急设备
          switch (this.eventResult) {
            case 'R1': // 创造起飞条件
              return e3
            case 'R2': // 滑回减员
              return e4
            case 'R3': // 公司决策
              return iconR3
            case 'R4': // 继续起飞
              return e6
          }
          break
        case 'CET4': // 冲击驾驶舱
          switch (this.eventResult) {
            case 'R1' :  // 立即滑回
            case 'R2' : // 紧急撤离
              return e2
          }
          break
        case 'CET5': // 机上吸烟
          switch (this.eventResult) {
            case 'R1' :  // 创造起飞条件
              return e3
            case 'R4' : // 继续起飞
              return e6
          }
          break
        case 'CET6': // 冲击机场/拒不下机
          switch (this.eventResult) {
            case 'R1' :  // 创造起飞条件
              return e3
            case 'R4' : // 继续起飞
              return e6
          }
          break
        case 'CET7': // 劫炸机
          switch (this.eventResult) {
            case 'R1': // 快速撤离
            case 'R2': // 紧急撤离
              return e2
            case 'R3': // 公司决策
              return iconR3
          }
          break
      }
      return ''
    },
    eventResultColor() {
      console.log(['this.eventType', this.eventType])
      if (!this.eventType) {
        return 'active' // 黄色
      }
      // return '' // 红色
      // return 'active' // 黄色
      // return 'active2' // 绿色
      switch (this.eventType) {
        case 'CET0': // 纵火
          // R1("快速撤离", "请指挥旅客快速撤离，并随时监控是否出现明火，完成检查单项目。", new String[]{"确定出现试图纵火的行为", "无人员反馈到明火或烟雾"}),
          // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"出现客舱纵火行为", "可观察到明火或烟雾"}),
          // R3("公司决策", "", new String[]{}),
          switch (this.eventResult) {
            case 'R1' :
              return 'active' // 黄色
            case 'R3' :
              return 'active3' // 蓝色
            case 'R2' :
              return '' // 红色
          }
          break
        case 'CET1': // 斗殴
          // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现斗殴的行为", "无人员反馈到严重的事态行为"}),
          // R2("滑回减员", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确定出现斗殴的行为", "已出现严重的事态行为"}),
          // R3("公司决策", "", new String[]{}),
          // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
          switch (this.eventResult) {
            case 'R1' :  // 黄色
              return 'active'
            case 'R3' :
              return 'active3' // 蓝色
            case 'R2' :
              return '' // 红色
            case 'R4' :
              return 'active2' // 绿色
          }
          break
        case 'CET2': // 劫炸机威胁
          // R1("立即滑回防爆停机位", "请立即滑回防爆停机位，并随时监控是否出现秩序失控，完成检查单项目", new String[]{"已出现严重的事态行为"}),
          // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"存在爆炸物风险"}),
          switch (this.eventResult) {
            case 'R1' :  // 黄色
              return 'active'
            case 'R2' :
              return '' // 红色
          }
          break
        case 'CET3': // 违规使用电子/应急设备
          // R1("创造条件起飞", "请尽可能创造起飞条件，并完成检查单项目。", new String[]{"确认违规使用电子/应急设备事件"}),
          // R2("滑回减员", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确认违规使用电子/应急设备事件", "已出现影响通讯情况", "已出现故障警告情况", "已出现开启或损坏紧急设备情况"}),
          // R3("公司决策", "", new String[]{}),
          // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
          switch (this.eventResult) {
            case 'R1' :  // 黄色
              return 'active'
            case 'R3' :
              return 'active3' // 蓝色
            case 'R2' :
              return '' // 红色
            case 'R4' :
              return 'active2' // 绿色
          }
          break
        case 'CET4': // 冲击驾驶舱
          // R1("立即滑回", "请立即滑回，并随时监控是否出现秩序失控，完成检查单项目", new String[]{"确定出现冲击驾驶舱行为"}),
          // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确定出现冲击驾驶舱行为", "已出现严重的事态行为"}),
          switch (this.eventResult) {
            case 'R1' :  // 黄色
              return 'active'
            case 'R2' :
              return '' // 红色
          }
          break
        case 'CET5': // 机上吸烟
          // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现机上吸烟行为", "无人员反馈到严重的事态行为"}),
          // R2("事件转变", "", new String[]{""}),
          // R3("-", "", new String[]{""}),
          // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
          switch (this.eventResult) {
            case 'R1' :  // 黄色
              return 'active'
            case 'R4' :
              return 'active2' // 绿色
          }
          break
        case 'CET6': // 冲击机场/拒不下机
          // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现冲击机场拒不下机行为", "无人员反馈到严重的事态行为"}),
          // R2("事件转变", "", new String[]{""}),
          // R3("-", "", new String[]{""}),
          // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
          switch (this.eventResult) {
            case 'R1' :  // 黄色
              return 'active'
            case 'R4' :
              return 'active2' // 绿色
          }
          break
        case 'CET7': // 劫炸机
          switch (this.eventResult) {
            case 'R1' :
              return 'active' // 黄色
            case 'R3' :
              return 'active3' // 蓝色
            case 'R2' :
              return '' // 红色
          }
          break
      }
    }
  },
  methods: {
    async findById() {
      const res = await detailById(this.id)
      if (res.code === 'A00000') {
        this.eventDataRow = res.data[0] || {}
        this.eventVO = this.eventDataRow[mapVO[this.eventType]] || {}
        if (!this.eventDataRow.done) {
          // this.popupConfirmDialog()
          // this.popupDoneConfirmDialog()
        }
        this.popupCurrentResultDialog()
      } else {
        this.$message.error(res.message)
      }
    },
    subscribeTopic() {
      if (this.enableMQTT && this.topic) {
        this.subscribeMQTT(this.topic, (message) => {
          this.onMessage(message);
        });
      }
    },
    onMessage(message) {
      if (message) {
        const res = JSON.parse(message.toString());
        this.eventDataRow = res || {};
        this.eventVO = this.eventDataRow[mapVO[this.eventType]] || {};
        // this.popupConfirmDialog()
        // this.popupDoneConfirmDialog()
        this.popupCurrentResultDialog();
      }
    },
    // popupConfirmDialog() {
    //   if (!this.hasSOC) {
    //     // 只有 SOC 弹确认窗口
    //     return
    //   }
    //   this.socConfirmDialog = this.eventVO.socConfirmDialog
    //   this.alertSocDoneConfirmDialog = this.eventVO.alertSocDoneConfirmDialog
    // },
    // popupDoneConfirmDialog() {
    //   if (!this.hasSOC) {
    //     // 只有 SOC 弹二次确认窗口
    //     return
    //   }
    //   this.socConfirmDialog = this.eventVO.socConfirmDialog || {visible: false}
    //   this.socConfirmDialog.visible = this.eventVO.alertSocConfirmDialog || false
    // },
    popupCurrentResultDialog(mouseClick) {
      if (mouseClick && this.eventDataRow.done) { // 鼠标点击事件触发
        this.currentResultDialog = this.eventVO.currentResultDialog
        this.alertCurrentResultDialog = true
      } else {
        if (this.hasSOC
          && (this.eventVO.alertSocConfirmDialog || this.eventVO.alertSocDoneConfirmDialog)) {
          // 当 SOC 弹确认窗口时，不用弹出当前决策窗口
          return
        }
        if (this.eventVO.alertCurrentResultDialog) {
          this.currentResultDialog = this.eventVO.currentResultDialog
          this.alertCurrentResultDialog = true
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.undefined {
  font-size: 14px;
  opacity: .5;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.interaction-box.active {
  .makepolicy-li:before {
    background: #5CBE85 !important;
  }

  .makepolicy-head span {
    color: #5CBE85 !important;
  }

  .makepolicy-laber {
    color: #5CBE85;
    background: rgba(92, 190, 133, 0.1);
  }
}

.interaction-box.active2 {
  .makepolicy-li:before {
    background: #E9463C !important;
  }

  .makepolicy-head span {
    color: #E9463C !important;
  }

  .makepolicy-laber {
    color: #E9463C;
    background: rgba(233, 70, 60, 0.1);
  }
}

.interaction-box.active3 {
  .makepolicy-li:before {
    background: #3F7CF6 !important;
  }

  .makepolicy-head span {
    color: #3F7CF6 !important;
  }

  .makepolicy-laber {
    color: #3F7CF6;
    background: rgba(39, 105, 236, 0.1);
  }
}

.interaction-box {
  .makepolicy-head {
    font-size: 18px;
    color: #fff;

    span {
      color: #EBA967;
    }
  }

  .makepolicy-box {
    background: #393F52;
    border-radius: 8px;
    padding: 16px;
    margin-top: 12px;

    .makepolicy-h {
      opacity: 0.6;
      font-size: 16px;
    }

    .makepolicy-li:before {
      content: '';
      display: block;
      position: absolute;
      width: 6px;
      height: 6px;
      background: #EBA967;
      border-radius: 50%;
      left: 0;
      top: 8px;
    }

    .makepolicy-li {
      color: rgba(255, 255, 255, 0.87);
      font-size: 16px;
      margin-top: 12px;
      padding-left: 18px;
      position: relative;
    }
  }

  .makepolicy-laber {
    background: rgba(233, 146, 60, 0.1);
    border-radius: 4px;
    height: 32px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    color: #EBA967;
    margin-top: 16px;
  }

  padding: 24px;

  .interaction-li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 24px;

    .interaction-left {
      width: 150px;
      text-align: left;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.87);
    }

    .interaction-left.active {
      line-height: 48px;
    }

    .interaction-right {
      flex: 1;
      position: relative;

      .evaluation-click {
        line-height: 48px;
      }
    }
  }
}

.bt-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;

  .bt {
    border-radius: 8px;
    flex: 1;
    margin: 0;
    height: 44px;
  }

  .bt2 {
    border-radius: 8px;
    width: 258px;
    margin-right: 24px;
    height: 44px;
  }
}

.evaluation-click {
  display: flex;
  color: rgba(255, 255, 255, 0.87);
  font-size: 14px;

  .click-li {
    margin-right: 24px;
    padding-left: 20px;
    background: url("~@/assets/images/123.png") no-repeat left center;
    background-size: 12px 12px;
    cursor: pointer;
  }

  .click-li.active {
    background: url("~@/assets/images/1234.png") no-repeat left center;
    background-size: 12px 12px;
  }
}

/deep/ .chart-container div {
  z-index: 3;
}

/deep/ .alarm-box .el-dialog__header {
  display: none;
}

/deep/ .alarm-box .el-dialog {
  position: absolute;
  margin-top: 0 !important;
  right: 0;
  background: #262D40;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  height: 100%;
  width: 600px;
}

/deep/ .alarm-box .el-dialog__body {
  padding: 0;
  text-align: left;
  color: #fff;
}

.operation-img {
  width: 100%;
  height: 94%;
  box-sizing: border-box;
  padding-left: 86px;
  padding-right: 100px;
}

.chart-container {
  width: 100%;
  height: 100%;
}

.interaction-head {
  font-size: 16px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modalclose {
  position: absolute;
  width: 20px;
  top: 22px;
  right: 16px;
  cursor: pointer;
}

/deep/ .interaction .el-dialog__header {
  display: none;
}

/deep/ .interaction .el-dialog {
  position: absolute;
  margin-top: 0 !important;
  background: url("~@/assets/images/index/xian.png") no-repeat #262D40;
  background-size: 100% 100%;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  width: 600px;
  left: calc(50% - 300px);
  top: calc(30%);
  border-radius: 8px;
  padding-bottom: 24px;

  .el-input__inner {
    height: 48px;
    background: #262D40;
    border: 1px solid #525F89;
    border-radius: 8px;
    color: #fff;
  }

  .el-textarea__inner {
    background: #393F52;
    border-radius: 8px;
    border: none;
    padding: 10px;
    height: 168px;
    color: #fff;
    font-size: 16px;
  }

  .el-select {
    width: 100%;
  }
}

/deep/ .interaction .el-dialog__body {
  padding: 0;
  text-align: left;
  color: #fff;
}

.backgroundList {
  background: #262D40;
  border-radius: 8px;
}

.Variousroles-head {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.87);
  line-height: 50px;
  margin-bottom: 6px;
  text-align: left;
}

.Variousroles-bt {
  height: 44px;
  cursor: pointer;
  background: #1F60C1;
  border-radius: 8px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.87);
  margin-top: 4px;
}

.Variousroles-ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: calc(100% - 120px);
  overflow: auto;

  .Variousroles-li:nth-child(2n) {
    margin-left: 16px;
  }

  .Variousroles-li {
    background: #393F52;
    border-radius: 8px;
    width: calc(50% - 8px);
    padding: 16px 0;
    margin-bottom: 16px;
  }

  .Variousroles-name {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.87);
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;

    span {
      color: #EBA967;
      font-size: 12px;
    }
  }

  .Variousroles-line {
    text-align: left;
    padding: 12px;
    border-bottom: 1px solid #262D40;

    .Variousroles-line-date {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.87);
    }

    .Variousroles-line-box {
      background: #0F1526;
      border-radius: 8px;
      height: 8px;
      position: relative;
      overflow: hidden;
      padding: 1px;
      margin-top: 8px;

      .line {
        background: linear-gradient(270deg, #83D7A5 0%, #65C58C 100%);
        border-radius: 8px;
        height: 100%;
      }
    }
  }

  .Variousroles-text {
    padding: 12px;
    height: 127px;
    overflow: auto;
    text-align: left;

    .Variousroles-p.active {
      color: #6CD8FF;
    }

    .Variousroles-p.active:before {
      background: #6CD8FF;
    }

    .Variousroles-p.active2 {
      color: #FFFFFF;
    }

    .Variousroles-p.active2:before {
      background: #fff;
    }

    .Variousroles-p.active3 {
      color: rgba(255, 255, 255, 0.6);
    }

    .Variousroles-p.active3:before {
      background: rgba(255, 255, 255, 0.6);
    }

    .Variousroles-p:before {
      content: '';
      display: block;
      position: absolute;
      width: 4px;
      height: 4px;
      background: #65C58C;
      border-radius: 50%;
      left: 0;
      top: 7px;
    }

    .Variousroles-p {
      position: relative;
      color: #65C58C;
      font-size: 12px;
      margin-bottom: 6px;
      line-height: 18px;
      padding-left: 12px;
    }
  }
}

.Eventhandling-left {
  flex: 1;
  padding: 0 16px;
}

.Eventhandling-center {
  width: 610px;
  margin: 0 22px;

  .center-top {
    height: 346px;
    box-sizing: border-box;
    position: relative;

    video {
      width: 100%;
      height: 100%;
      background: #000;
    }

    .picture-text {
      position: absolute;
      text-align: left;
      left: 16px;
      top: 16px;

      .picture-h {
        font-size: 16px;
      }

      .picture-p {
        color: #7A7C87;
        font-size: 12px;
        margin-top: 2px;
      }
    }
  }

  .inspection-p {
    opacity: 0.6;
    font-size: 14px;
    text-align: left;
  }

  .inspection-bt {
    height: 44px;
    cursor: pointer;
    background: #1F60C1;
    border-radius: 8px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.87);
    margin-top: 4px;
    position: absolute;
    left: 16px;
    width: calc(100% - 32px);
    bottom: 16px;
  }

  .inspection-ul {
    max-height: 190px;
    overflow: auto;

    .bbt {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 24px;
      margin-top: 12px;
      width: 100%;

      .bt {
        width: 72px;
        height: 26px;
        border: 0.5px solid #6CD8FF;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        margin: 0;
        color: #6CD8FF;
        font-size: 14px;
      }

      .bt2 {
        width: 72px;
        height: 26px;
        border: 0.5px solid #E9463C;
        border-radius: 4px;
        display: flex;
        align-items: center;
        color: #E9463C;
        font-size: 14px;
        justify-content: center;
      }
    }

    .inspection-li.text {
      background: #393F52;
      border-radius: 8px;
      padding: 5px;
      height: auto;
      display: block;

      .text-top {
        display: flex;
      }

      .inspection-text {
        border: none;
        overflow: initial; //超出隐藏
        white-space: initial; //不折行
        text-overflow: initial; //溢出显示省略号
        color: rgba(255, 255, 255, 0.87);
        line-height: 24px;
      }
    }

    /deep/ .inspection-li.active {
      .el-checkbox {
        color: #6CD8FF;
      }

      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #6CD8FF;
      }

      .el-checkbox__inner {
        border-color: #6CD8FF;
        background: #6CD8FF;
      }
    }

    /deep/ .inspection-li.active3 {
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #5CBE85;
      }

      .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: #5CBE85;
        border-color: #5CBE85;
      }
    }

    /deep/ .inspection-li.active2 {
      /* .el-checkbox__input.is-checked+.el-checkbox__label{
         color: rgba(255, 255, 255, 0.6);
       }*/

      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #606266;
      }
    }

    .inspection-li {
      min-height: 58px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      text-align: left;
      padding: 12px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #2B3245;

      .inspection-icon.active {
        background: url("~@/assets/images/c2.png") no-repeat;
        background-size: 100% 100%;
      }

      .inspection-icon.active2 {
        background: url("~@/assets/images/c3.png") no-repeat;
        background-size: 100% 100%;
      }

      .inspection-icon {
        width: 20px;
        height: 20px;
        background: url("~@/assets/images/c1.png") no-repeat;
        background-size: 100% 100%;
        margin-right: 12px;
      }

      .inspection-text {
        flex: 1;
        color: #5CBE85;
        font-size: 16px;
        overflow: hidden; //超出隐藏
        white-space: nowrap; //不折行
        text-overflow: ellipsis; //溢出显示省略号
        border-bottom: 1px solid #303749;
        height: 100%;
        line-height: 60px;
      }

      .el-checkbox {
        color: #C0C4CC;
      }
    }
  }

  .center-bottom {
    height: calc(100% - 368px);
    margin-top: 22px;
    position: relative;

    .inspection-h {
      color: rgba(255, 255, 255, 0.87);
      font-size: 16px;
      line-height: 16px;
      margin-bottom: 20px;
      text-align: left;
      padding: 16px;
      padding-bottom: 0;
      height: 20px;
    }

    .inspection-bottom {
      padding: 16px;
      height: calc(50% - 20px);
    }

    .inspection-top {
      border-bottom: 1px solid #0F1526;
      height: calc(50% - 90px);
      padding: 16px;
      padding-top: 0;
      text-align: left;

      .inspection-h {
        color: rgba(255, 255, 255, 0.87);
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 20px;
      }
    }
  }
}

.Eventhandling-right {
  width: 450px;

  .right-top {
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 23px;

    .Aircraftclass-li:last-child {
      border: 0;
    }

    .Aircraftclass-li {
      width: 33.3%;
      border-right: 1px solid rgba(255, 255, 255, 0.1);

      .Aircraftclass-h {
        opacity: 0.87;
        font-size: 18px;
        line-height: 18px;
      }

      .Aircraftclass-p {
        opacity: 0.7;
        font-size: 12px;
        margin-top: 8px;
      }
    }
  }
  .right-center.CET0 {
    background: url('~@/assets/images/index/ss1.png') no-repeat 70% 0 #8D0F06;
    background-size: 92px;
  }
  .right-center.CET2 {
    background: url('~@/assets/images/index/ss4.png') no-repeat 70% 0 #8D0F06;
    background-size: 92px;
  }
  .right-center.CET4 {
    background: url('~@/assets/images/index/ss7.png') no-repeat 70% 0 #8D0F06;
    background-size: 92px;
  }
  .right-center.CET1 {
    background: url('~@/assets/images/index/ss2.png') no-repeat 70% 0 #1F8D4B;
    background-size: 92px;
  }
  .right-center.CET3 {
    background: url('~@/assets/images/index/ss5.png') no-repeat 70% 0 #1F8D4B;
    background-size: 92px;
  }
  .right-center.CET5 {
    background: url('~@/assets/images/index/ss3.png') no-repeat 70% 0 #164B9A;
    background-size: 92px;
  }
  .right-center.CET6 {
    background: url('~@/assets/images/index/ss6.png') no-repeat 70% 0 #164B9A;
    background-size: 92px;
  }
  .right-center.CET7 {
    background: url('~@/assets/images/index/ss1.png') no-repeat 70% 0 #8D0F06;
    background-size: 92px;
  }
  .right-center {
    background: no-repeat 177px 0 #8D0F06;
    background-size: 174px;
    border-radius: 8px;
    height: 242px;
    margin: 22px 0;
    overflow: hidden;

    .event-top {
      position: relative;
      padding: 12px;
      text-align: left;
      height: 78px;
      box-sizing: border-box;

      .event-h {
        font-size: 14px;
        line-height: 14px;
        color: #FFFFFF;
        opacity: 0.87;
      }

      .event-p {
        font-size: 24px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.87);
        font-weight: bold;
        margin-top: 12px;
      }

      .event-bt {
        position: absolute;
        right: 12px;
        background: rgba(255, 255, 255, .2);
        backdrop-filter: blur(6px);
        border-radius: 4px;
        width: 88px;
        height: 28px;
        font-size: 12px;
        color: rgba(255, 255, 255, .9);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        top: 25px;
      }
    }

    .event-bottom.none {
      display: block;
      background: #262D40;
      border: none;
      padding: 16px 15px;

      .none-h {
        font-size: 16px;
        line-height: 16px;
        /* identical to box height, or 100% */
        color: rgba(255, 255, 255, 0.87);
        text-align: left;
      }

      .none-p {
        font-size: 12px;
        line-height: 12px;
        /* identical to box height, or 100% */
        text-align: center;
        color: #FFFFFF;
        opacity: 0.3;
        margin-top: 45px;
      }
    }

    .event-bottom.active {
      background: radial-gradient(317.87% 210.5% at 46.43% -60.5%, #FFEBD8 18.21%, #F0B177 35.26%, #EB8D2F 61.73%);
      border: 1px solid #E5BD96;
    }

    .event-bottom.active2 {
      background: linear-gradient(180deg, #D6F4D1 -34.33%, #9BEA8E 11.98%, #65B259 82.96%);
      border: 1px solid #9CE78F;
    }

    .event-bottom.active3 {
      border: 1px solid #3F7CF6FF;
      background: radial-gradient(317.87% 210.5% at 46.43% -60.5%, #C1D6FF 2.41%, #3F7CF6 35.18%, #346DDE 64.15%, #346DDE 100%);
    }

    .event-bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      background: radial-gradient(331.64% 219.62% at 46.83% -100%, #F5D8D9 2.41%, #F27578 35.18%, #D93F43 64.15%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
      border: 1px solid #EF7D80;
      border-radius: 8px;
      height: calc(100% - 78px);
      cursor: pointer;
      img {
        width: 44px;
        margin-bottom: 12px;
      }

      .event-t {
        font-size: 20px;
        color: rgba(255, 255, 255, .7);
        line-height: 20px;
      }
    }
  }

  .right-bottom {
    height: calc(100% - 364px);
    position: relative;

    .evaluation-bottom {
      padding: 8px;
      text-align: left;
      height: calc(100% - 150px);

      .evaluation-head {
        background: rgba(235, 169, 103, 0.1);
        border-radius: 4px;
        height: 32px;
        color: #EBA967;
        font-size: 12px;
        display: flex;
        align-items: center;
        padding: 0 12px;
      }

      .evaluation-ul {
        padding: 16px;
        height: calc(100% - 120px);
        overflow: auto;

        .evaluation-li:last-child {
          margin-bottom: 0;
        }

        .evaluation-li {
          margin-bottom: 48px;

          .evaluation-title {
            color: rgba(255, 255, 255, 0.87);
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 16px;
          }
        }
      }

      .evaluation-bt {
        color: rgba(255, 255, 255, 0.87);
        border-radius: 8px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #2769EC;
        cursor: pointer;
        position: absolute;
        width: calc(100% - 32px);
        left: 16px;
        bottom: 16px;
      }

      .evaluation-bt.active {
        background: #393F52;
      }
    }

    .evaluation-s {
      color: rgba(255, 255, 255, 0.87);
      font-size: 16px;
      line-height: 16px;
      padding: 16px;
      text-align: left;
    }

    .evaluation-top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 16px;
      border-bottom: 1px solid #0F1526;

      .evaluation-laber:nth-child(3n) {
        margin-right: 0;
      }

      .evaluation-laber {
        background: #393F52;
        border-radius: 4px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        width: calc(33.3% - 8px);
        margin-bottom: 12px;
        color: rgba(255, 255, 255, 0.87);
        font-size: 14px;

        span {
          width: 8px;
          height: 8px;
          margin-right: 4px;
          border-radius: 50%;
        }
      }

      .evaluation-laber.active {
        background: #2769EC;
      }
    }
  }
}

.decision-page {
  display: flex;
  justify-content: space-between;
  height: calc(100vh - 145px);
  min-height: 900px;
  max-height: 1080px;
}
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/CabinEvent.vue